import { clearAllData } from '@/services/offline/db';
import { connectivityMonitor } from '@/services/offline/connectivityMonitor';
import { prefetchService } from '@/services/offline/prefetchService';

// Calendar location resets on logout so the next session defaults to the
// user's primary location. Deliberate preferences survive: selected providers,
// view mode, provider drag-drop order, days-in-week, grid view, panel toggles.
const CALENDAR_SESSION_KEYS = [
  'calendar_location_view',
];

export async function purgeOfflineData() {
  try {
    sessionStorage.removeItem('prism_rtb_filters');
    sessionStorage.removeItem('calendar_custom_grid_date');
    CALENDAR_SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
    prefetchService.abort();
    connectivityMonitor.destroy();
    await clearAllData();
  } catch (err) {
    console.error('[LogoutCleanup] Failed to purge offline data:', err);
  }
}

export async function performLogout(logout) {
  await purgeOfflineData();

  if (!navigator.onLine) {
    window.location.href = '/';
    return;
  }

  logout({
    logoutParams: {
      returnTo: window.location.origin,
    },
  });
}
